import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Masked line reveal — wrap short phrases / single lines.
// NOTE: useInView observes the OUTER wrapper (not the translated inner span).
// Observing the inner span is unreliable because its initial y:115% offset sits
// outside the wrapper's overflow-hidden clip box, so IntersectionObserver can
// report it as never intersecting and the text stays permanently hidden.
export const Reveal = ({ children, delay = 0, className = "", as: Tag = "span", load = false }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px" });
  const show = load || inView;
  return (
    <Tag ref={ref} className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "115%" }}
        animate={show ? { y: 0 } : { y: "115%" }}
        transition={{ duration: 0.9, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </Tag>
  );
};

// Simple fade-up for blocks
export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);
